var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0.75L8.45863 1.63414C9.29605 5.183 12.067 7.95394 15.6159 8.79137L16.5 9L15.6159 9.20863C12.067 10.0461 9.29605 12.817 8.45863 16.3659L8.25 17.25L8.04137 16.3659C7.20395 12.817 4.433 10.0461 0.884142 9.20863L0 9L0.884141 8.79137C4.433 7.95395 7.20394 5.183 8.04137 1.63414L8.25 0.75Z",
    fill: "#73C947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.4e35e0543e750df949b849f79dc1af04.svg";
export { ForwardRef as ReactComponent };